import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

function AutoScroll({ pathname, hash }) {
  // Handle scroll to top when changing routes.
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  // Handle scroll to same page ID element on mount.
  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 500);
    }
  }, []);
}

AutoScroll.propTypes = {
  /**
   * The pathname
   */
  pathname: PropTypes.string,
  /**
   * The hash
   */
  hash: PropTypes.string
};

export default AutoScroll;
